import classNames from 'classnames';
import { addMonths, format, subMonths } from 'date-fns';
import { FC, useEffect, useState } from 'react';
import CalendarBody from '../components/eventCalendarComponents/CalendarBody';
import CalendarHeader from '../components/eventCalendarComponents/CalendarHeader';
import WeekDaysNames from '../components/eventCalendarComponents/WeekDaysNames';
import { ICalendarEvent } from '../types';

interface IProps {}

const EventCalendar: FC<IProps> = () => {
  const [selectedDate, setSelectedDate] = useState(null);
  const [activeDate, setActiveDate] = useState(new Date());
  const [selectedEventId, setSelectedEventId] = useState<number | null>(null);

  const [calendarEvents, setCalendarEvents] = useState<ICalendarEvent[]>([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    fetch('/wp-json/sw/v1/events')
      .then(response => response.json())
      .then((eventCalendarResponseData: ICalendarEvent[]) => {
        setCalendarEvents(eventCalendarResponseData);
      })
      .finally(() => setLoading(false));
  }, []);

  const onEventClick = (day: Date) => (eventId: number | null) => {
    setSelectedEventId(eventId);
    if (!eventId) {
      setSelectedDate(null);
    } else {
      setSelectedDate(day);
    }
  };
  return (
    <section
      className={classNames('event-calendar', {
        'event-calendar__loading': loading,
      })}
    >
      <CalendarHeader
        onTodayClick={() => {
          setActiveDate(new Date());
        }}
        onPrevClick={() => setActiveDate(subMonths(activeDate, 1))}
        onNextClick={() => setActiveDate(addMonths(activeDate, 1))}
        currentMonth={format(activeDate, 'MMMM yyyy')}
      />
      <WeekDaysNames activeDate={activeDate} />
      <CalendarBody
        events={calendarEvents}
        activeDate={activeDate}
        onEventClick={onEventClick}
        selectedDate={selectedDate}
        selectedEventId={selectedEventId}
      />
    </section>
  );
};
export default EventCalendar;
